import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/regionen/frankfurt")({
  head: () => {
    const h = pageHead("region:frankfurt", "de");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="frankfurt" locale="de" />,
});
